import React, { useRef } from 'react'
import { useScaleToFit } from '@hooks'

interface BSModalButtonProps {
    id: string
    text: string
    isPrimary?: boolean
    onClick: () => void
}

const BSModalButton: React.FC<BSModalButtonProps> = ({ id, text, isPrimary = true, onClick }: BSModalButtonProps) => {
    const mainButtonsStyles = `text-[30px] text-white border-none rounded cursor-pointer font-bold transition-colors duration-300 w-[278px] h-[88px] flex items-center justify-center leading-[1.2]`
    const primaryBtnBackground = `bg-[url('/src/assets/bonus-system/button-primary-enabled.svg')] bg-cover bg-no-repeat bg-center hover:bg-[url('/src/assets/bonus-system/button-primary-hovered.svg')] active:bg-[url('/src/assets/bonus-system/button-primary-pressed.svg')]`
    const secondaryBtnBackground = `bg-[url('/src/assets/bonus-system/button-secondary-enabled.svg')] bg-cover bg-no-repeat bg-center hover:bg-[url('/src/assets/bonus-system/button-secondary-hovered.svg')] active:bg-[url('/src/assets/bonus-system/button-secondary-pressed.svg')]`
    const buttonComponentRef = useRef<HTMLButtonElement | null>(null)
    const buttonContentRef = useRef<HTMLSpanElement | null>(null)
    const scale = useScaleToFit(buttonComponentRef, buttonContentRef, [text], 0.9)

    return (
        <button
            ref={buttonComponentRef}
            id={id}
            className={`${mainButtonsStyles} ${isPrimary ? primaryBtnBackground : secondaryBtnBackground}`}
            onClick={onClick}
        >
            <span
                ref={buttonContentRef}
                style={{
                    zoom: scale,
                }}
                className={'whitespace-nowrap'}
            >
                {text}
            </span>
        </button>
    )
}

export default BSModalButton
